import { render, staticRenderFns } from "./LandfillBalancePage.vue?vue&type=template&id=442f2c9a&scoped=true"
import script from "./LandfillBalancePage.vue?vue&type=script&lang=js"
export * from "./LandfillBalancePage.vue?vue&type=script&lang=js"
import style0 from "./LandfillBalancePage.vue?vue&type=style&index=0&id=442f2c9a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f2c9a",
  null
  
)

export default component.exports